// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"9":"3d8048a2","384":"2dde771b"}[chunkId] + ".chunk.css";
};